module.exports = __webpack_public_path__ + "img/step3.7364bd57.png";